import { RatingStarIcon, RatingStarFillIcon } from '@shipt/design-system-icons'
import { Box, Row } from '@shipt/design-system-layouts'
import styled from 'styled-components'

type SizeType = 'sm' | 'md' | 'lg'

type Props = {
  rating: number
  size?: SizeType
  isProductCard?: boolean
}

const sizeMap = {
  sm: 13,
  md: 16,
  lg: 20,
}

export const ProductDetailStars = ({ rating, size = 'sm', isProductCard = false }: Props) => {
  return (
    <Row role="img" align="center" aria-label={`Rating: ${rating.toFixed(1)} out of 5 stars`}>
      {[1, 2, 3, 4, 5].map((pos) => {
        const fillPercentage = Math.min(Math.max((rating - (pos - 1)) * 100, 0), 100)

        return (
          <StarContainer key={pos} size={size}>
            <RatingStarIcon variant={isProductCard ? 'secondary' : 'primary'} />
            <StarIconFill
              variant={isProductCard ? 'secondary' : 'primary'}
              fillPercentage={fillPercentage}
            />
          </StarContainer>
        )
      })}
    </Row>
  )
}

const StarContainer = styled(Box)<{
  size: SizeType
}>`
  position: relative;
  width: ${({ size }) => `${sizeMap[size]}px`};
  height: ${({ size }) => `${sizeMap[size]}px`};
  margin-right: ${({ size }) => (size === 'md' ? '3px' : '2.3px')};

  svg {
    position: absolute;
    width: 100%;
    height: 100%;
  }
`

const StarIconFill = styled(RatingStarFillIcon)<{ fillPercentage: number }>`
  clip-path: ${({ fillPercentage }) => `inset(0 ${100 - fillPercentage}% 0 0)`};
`
